export interface CallDispositionReportParameter {
   value: ReportCallDispositions;
}

export enum ReportCallDispositions {
   'Voicemail' = 'Voicemail',
   'Missed' = 'Missed',
   'Both' = 'Both',
}
